import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import { memberApi } from '@formosa/shared/api/member';
import { useAuth } from '../auth/AuthContext';

const WalletContext = createContext(null);

export function WalletProvider({ children }) {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(false);

  const refreshWallet = useCallback(async () => {
    if (!isAuthenticated) {
      setBalance(null);
      return;
    }
    setLoading(true);
    try {
      const data = await memberApi.getWallet();
      setBalance(data?.memberWallet?.balance ?? '—');
    } catch {
      setBalance('—');
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    refreshWallet();
  }, [location.pathname, refreshWallet]);

  const value = useMemo(
    () => ({
      balance,
      loading,
      refreshWallet,
    }),
    [balance, loading, refreshWallet]
  );

  return (
    <WalletContext.Provider value={value}>{children}</WalletContext.Provider>
  );
}

export function useWallet() {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error('useWallet 必須在 WalletProvider 內使用');
  }
  return context;
}
